<template>
  <svg
    width="3"
    height="10"
    viewBox="0 0 3 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.3125 9.75V3.3741H2.6875V9.75H0.3125ZM0.3125 2.16275V0.25H2.6875V2.16275H0.3125Z"
      fill="currentColor"
    />
  </svg>
</template>
